const benefits = [
  {
    icon: "ri-sun-line",
    title: "Idealny Klimat 365 Dni",
    desc: "350+ dni słonecznych rocznie i średnia temperatura 25°C. Trenuj na zewnątrz przez cały rok.",
    image: "https://api.playitas.net/sites/default/files/styles/one_third_hight/public/2023-06/Running.jpg?h=10d202d3&itok=vDqCX6Iu",
    bg: "bg-rose-50",
    iconColor: "text-orange-500",
  },
  {
    icon: "ri-team-line",
    title: "Networking Profesjonalny",
    desc: "Poznaj innych trenerów i sportowców z całej Europy. Buduj wartościowe kontakty.",
    image: "https://api.playitas.net/sites/default/files/styles/one_third_hight/public/2023-06/triathlon.jpg?h=10d202d3&itok=UWgU4pxU",
    bg: "bg-emerald-50",
    iconColor: "text-emerald-500",
  },
  {
    icon: "ri-hotel-line",
    title: "Zakwaterowanie All-Inclusive",
    desc: "Komfortowe pokoje, pełne wyżywienie i wszystkie udogodnienia w jednej cenie.",
    image: "https://api.playitas.net/sites/default/files/styles/one_third_hight/public/2021-12/hotelroom.jpg?h=739c408f&itok=V_a6m03G",
    bg: "bg-gray-100",
    iconColor: "text-gray-700",
  },
  {
    icon: "ri-restaurant-line",
    title: "Zdrowe Odżywianie",
    desc: "Pełne menu sportowe z opcjami dostosowanymi do potrzeb sportowców.",
    image: "https://api.playitas.net/sites/default/files/styles/one_third_hight/public/2022-06/Da_Luigi_02.jpg?h=5d1b1732&itok=iGR-cwKT",
    bg: "bg-amber-50",
    iconColor: "text-amber-600",
  },
];

export default function PlayitasBenefits() {
  return (
    <>
      <section id="b2b" className="py-32 px-6 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gray-500 text-sm tracking-widest mb-4">DLA AGENCJI I FIRM</p>
            <h2 className="text-5xl md:text-6xl font-bold mb-6">
              <span className="font-normal">Idealne miejsce na</span><br />
              <span className="font-bold italic">obozy sportowe i eventy korporacyjne</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {[
              {
                badge: "AGENCJE TURYSTYKI SPORTOWEJ", badgeColor: "bg-teal-500",
                title: "Twój Partner w Organizacji Obozów",
                image: "https://api.playitas.net/sites/default/files/styles/hero/public/2024-08/Gym_03.JPG?h=10d202d3&itok=biGrUylx",
                items: ["Pakiety all-inclusive", "Koordynacja logistyczna", "Specjalne warunki dla agencji", "Doświadczenie i referencje"],
                note: "Agencji specjalizujących się w turystyce sportowej, obozach treningowych i grupach fitness",
                btnColor: "bg-teal-500 hover:bg-teal-600",
                checkColor: "text-teal-500", infoBg: "bg-teal-50", infoText: "text-teal-800",
              },
              {
                badge: "EVENTY KORPORACYJNE", badgeColor: "bg-orange-500",
                title: "Incentive & Team Building",
                image: "https://api.playitas.net/sites/default/files/styles/hero/public/2024-04/swimming.jpg?h=10d202d3&itok=QCMUNG_L",
                items: ["Programy team building", "Wellness & regeneracja", "Sale konferencyjne", "Programy na zamówienie"],
                note: "Wyjazdów motywacyjnych, integracji zespołów, eventów wellness i programów zdrowotnych",
                btnColor: "bg-orange-500 hover:bg-orange-600",
                checkColor: "text-orange-500", infoBg: "bg-orange-50", infoText: "text-orange-800",
              },
            ].map(card => (
              <div key={card.title} className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all group">
                <div className="relative h-80 overflow-hidden">
                  <img src={card.image} alt={card.title}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                  <div className="absolute bottom-6 left-6 right-6">
                    <div className={`inline-block ${card.badgeColor} text-white px-4 py-2 rounded-full font-bold text-sm mb-3`}>{card.badge}</div>
                    <h3 className="text-3xl font-bold text-white">{card.title}</h3>
                  </div>
                </div>
                <div className="p-8">
                  <div className="space-y-4 mb-8">
                    {card.items.map(item => (
                      <div key={item} className="flex items-start gap-3">
                        <i className={`ri-check-double-line text-2xl ${card.checkColor}`} />
                        <span className="font-semibold text-gray-900">{item}</span>
                      </div>
                    ))}
                  </div>
                  <div className={`${card.infoBg} rounded-2xl p-6 mb-6`}>
                    <p className={`text-sm ${card.infoText}`}>🎯 <strong>Idealne dla:</strong> {card.note}</p>
                  </div>
                  <button onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
                    className={`w-full h-16 ${card.btnColor} text-white font-bold text-lg rounded-xl transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-3`}>
                    SKONTAKTUJ SIĘ Z NAMI <i className="ri-arrow-right-line text-xl" />
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12 text-white">
            <h3 className="text-3xl font-bold text-center mb-12">Dlaczego Playitas Resort dla grup?</h3>
            <div className="grid md:grid-cols-4 gap-8">
              {[
                { icon: "ri-group-line", title: "Pojemność", desc: "Grupy od 10 do 500+ osób", color: "text-orange-400" },
                { icon: "ri-service-line", title: "Obsługa 24/7", desc: "Dedykowany koordynator", color: "text-emerald-400" },
                { icon: "ri-settings-3-line", title: "Elastyczność", desc: "Programy na Twoje potrzeby", color: "text-orange-400" },
                { icon: "ri-medal-line", title: "Doświadczenie", desc: "20+ lat eventów grupowych", color: "text-teal-400" },
              ].map(item => (
                <div key={item.title} className="text-center">
                  <div className="w-20 h-20 flex items-center justify-center bg-white/10 rounded-full mx-auto mb-4">
                    <i className={`${item.icon} text-4xl ${item.color}`} />
                  </div>
                  <h4 className="font-bold text-lg mb-2">{item.title}</h4>
                  <p className="text-gray-300 text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="benefits" className="py-32 px-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gray-500 text-sm tracking-widest mb-4">DLACZEGO PLAYITAS</p>
            <h2 className="text-5xl md:text-6xl font-bold mb-6">
              <span className="font-normal">Ekskluzywne korzyści dla</span><br />
              <span className="font-bold italic">profesjonalistów fitness</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-4 gap-8">
            {benefits.map(b => (
              <div key={b.title} className={`${b.bg} rounded-2xl overflow-hidden hover:shadow-xl transition-shadow`}>
                <div className="p-6">
                  <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full mb-6 mx-auto">
                    <i className={`${b.icon} text-4xl ${b.iconColor}`} />
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-center">{b.title}</h3>
                  <p className="text-gray-700 text-center mb-6">{b.desc}</p>
                </div>
                <div className="relative h-64">
                  <img src={b.image} alt={b.title} className="w-full h-full object-cover object-center" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://api.playitas.net/sites/default/files/styles/fullwidth_slider/public/2019-04/biking_mood_0.jpg?h=9559db38&itok=QraUXqCG"
            alt="Playitas" className="w-full h-full object-cover object-center" />
          <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative z-10 text-center px-6">
          <h2 className="text-6xl md:text-7xl font-black text-white mb-8 tracking-wider">ROZPOCZNIJ WSPÓŁPRACĘ</h2>
          <p className="text-2xl text-white/95 mb-4">Dołącz do społeczności trenerów elitarnych</p>
          <p className="text-2xl text-white/95 mb-12">którzy wybierają Playitas Resort na swoje obozy treningowe</p>
          <button onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
            className="inline-flex items-center gap-4 bg-orange-500 hover:bg-orange-600 text-white px-12 py-6 rounded-full text-lg font-bold transition-all cursor-pointer whitespace-nowrap shadow-2xl hover:scale-105">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-600 rounded-full">
              <i className="ri-file-list-3-line text-2xl" />
            </div>
            ZAREJESTRUJ SIĘ JAKO WSPÓŁPRACOWNIK
            <i className="ri-arrow-right-up-line text-2xl" />
          </button>
        </div>
      </section>
    </>
  );
}
